// extracted by mini-css-extract-plugin
export default {"searchInputWrapper":"customSearch_searchInputWrapper__iEBdJ","searchIcon":"customSearch_searchIcon__nYJHw","searchInput":"customSearch_searchInput__RccTo"};